// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import CreatableSelect from 'react-select/creatable';

import '../styles/editable.css';

export default class EditableMulti extends React.Component {

    state = {
        input: ""
    }
    
    render = () => {
        return (<div
            className={this.props.className ? this.props.className : ""}
            style={this.props.style ? this.props.style : {}}
        >
            <CreatableSelect
                components={{
                    ...(this.props.hideMenu ? { Menu: () => null } : {}),
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null
                }}
                className={this.props.selectClassName ? this.props.selectClassName : "multi-select-container"}
                classNamePrefix={this.props.selectClassPrefix ? this.props.selectClassPrefix : "multi-select"}
                placeholder={this.props.placeholder ? this.props.placeholder : ""}
                isMulti
                options={this.props.options ? this.props.options : []}
                defaultMenuIsOpen={this.props.defaultMenuIsOpen ? this.props.defaultMenuIsOpen : false}
                
                onChange={(value) => this.props.onChange(value)}
                value={this.props.value}

                onInputChange={(input) => this.setState({ input })}
                inputValue={this.state.input}

            />
        </div>)
    }

};